import React, { useEffect, useState, useRef } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
  Spinner,
} from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Formik } from "formik";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import InputText from "../../../components/common/InputText";

import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

import { AddUserSchema } from "validations/Users";
import { addSubUserApiCall } from "services/userService";
import storage from "helpers/storage";
import InputPhoneMask from "components/common/InputPhoneMask";


export const AddUser = () => {
  const [loading, setLoading] = useState(false);
  const navegate = useNavigate()
  const userInformation: {
    id: number;  
    company_name : string;
  } = storage.getData("user-info");
  let initialValues = {
    first_name : "",
    last_name :"",
    email :"",
    phone :"",
    designation :"",
    parent_id  : userInformation.id,
    company_name : userInformation.company_name
  };
  const handleSubmit = async (values: any, actions: any) => {
    
    setLoading(true);

    addSubUserApiCall(values).then(response => {
      setLoading(false);

      toast.success(response);
      navegate(nameBasedProtectedRoutes.users.path)

      
     }).catch(error => {
       
     toast.error(error.response.data.message);

      setLoading(false);
      
  })    
    
  };

  return (
    <>
      <section className="profile-main pt-4 dashboard-content faq-content">
        <Container className="">
          <Row>
            <Col md={12} lg={12}>
              <Breadcrumb className="border-0 shadow-none mb-0">
                <Breadcrumb.Item
                  className="fs-15 fw-semibold text-link"
                  href="Javascript:void(0)"
                >
                  <Link to={nameBasedProtectedRoutes.users.path} >Users</Link>
                </Breadcrumb.Item>

                <Breadcrumb.Item active className="fs-15 fw-semibold text-gray">
                Add User
                </Breadcrumb.Item>
              </Breadcrumb>
              <h1 className="fs-30 fw-bold mb-0 mt-1">Add User</h1>
            </Col>
          </Row>

          
          
            <Row className="mt-4">
              
                 
              <Formik
                initialValues={initialValues}
                validationSchema={AddUserSchema}
                onSubmit={handleSubmit}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                  setFieldError,
                  setValues,
                }) => (
                  <Form className="pe-xl-3" noValidate onSubmit={handleSubmit}>
                   
                    <Row>
                      <Col md={7} lg={7}>
                        <Card className="border-0 mb-3">
                          <Card.Body className="br-10 p-4">
                            
                            <div className="col-xl-12">
                              <Row>
                                <Col md="12">
                                  <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-4 text-uppercase">
                                  USER INFORMATION
                                  </h2>
                                </Col>
                              </Row>
                              
                              <Row>
                                <Col lg="6">
                                  <InputText
                                        controlId="first_name"
                                        label="First Name"
                                        placeholder="First Name"
                                        touched={touched.first_name}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={errors.first_name}
                                        value={values.first_name}
                                      />
                                </Col>
                                <Col lg="6">
                                  <InputText
                                    controlId="last_name"
                                    label="Last Name"
                                    placeholder="Last Name"
                                    touched={touched.last_name}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.last_name}
                                    value={values.last_name}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                    <Col lg="6">
                                      <InputText
                                        controlId="email"
                                        label="Email"
                                        placeholder="Email"
                                        touched={touched.email}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={errors.email }
                                        value={values.email}
                                      />
                                    </Col>
                                    <Col lg="6">
                                    <InputPhoneMask
                                    controlId="phone"
                                    label="Phone Number"
                                    placeholder="Phone Number"
                                    touched={touched.phone}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    errorsField={errors.phone}
                                    value={values.phone}
                                    mask="999-999-9999"
                                  />
                                   
                                  </Col>
                              </Row>
                              <Row>
                                    <Col lg="6">
                                      <InputText
                                        controlId="designation"
                                        label="Designation"
                                        placeholder="Designation"
                                        touched={touched.designation}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={ errors.designation}
                                        value={values.designation}
                                      />
                                    </Col>
                                    
                              </Row>
                              
                            </div>

                            {/*Decal Information*/}
                          </Card.Body>
                        </Card>
                        <Row>
                          <Col sm="12" className="d-flex justify-content-end">
                            <Link
                              to={nameBasedProtectedRoutes.users.path}
                              className="btn btn-light my-1 fw-semibold me-2"
                            >
                              Cancel
                            </Link>
                            {loading ? <Button
                              type="submit"
                              variant="primary"
                              className="btn btn-primary my-1 fw-semibold"
                              disabled
                            >
                              <Spinner size="sm" />
                            </Button>:<Button
                              type="submit"
                              variant="primary"
                              className="btn btn-primary my-1 fw-semibold"
                            >
                              Submit
                            </Button>}
                          </Col>
                        </Row>
                      </Col>
                      <Col md={5} lg={5} >
                          <Row className="mt-md-0 mt-3">
                            <Col md="12">
                              <h2 className="fs-20 fw-bold ls-2  mb-4 text-uppercase">
                              INSTRUCTIONS
                              </h2>
                              <ul className="fs-13 black-color adduser-list">
                                <li className="mb-2">The newly registered user will receive a welcome email containing a link to set up their login credentials.</li> 
                                <li className="mb-2">As the user will have complete access to the system, it is essential to ensure that they are aware of and equally responsible for all the activities they will perform on the system.</li>
                                <li className="mb-2">It is advisable to delete unnecessary user accounts at the earliest convenience to maintain system security and efficiency.</li>
                              </ul>
                            </Col>
                          </Row>
                      </Col>
                    </Row>
                   
                  </Form>
                )}
              </Formik>
            
                    
                  
            </Row>
          
        </Container>
      </section>

      
    </>
  );
};
